import { QueryEntity } from "@datorama/akita";
import { singleton } from "tsyringe";

import ReviewsGalleryStore, {
    ReviewsGalleryState,
} from "../stores/ReviewsGalleryStore";

@singleton()
class ReviewsGalleryQuery extends QueryEntity<ReviewsGalleryState> {
    constructor(protected store: ReviewsGalleryStore) {
        super(store);
    }

    active$ = this.selectActive();
    all$ = this.selectAll();
    reviews$ = this.select((state) => state.entities);
}

export default ReviewsGalleryQuery;
